import suburbsSrvc from 'services/suburbs'
import titleCase from 'utils/titleCase'

const sanitizeUrl = str => encodeURI(str.toLowerCase())

export const addressToSuburbLink = ({ city, suburb } = {}) => {
  const isCitySupported =
    city &&
    !!suburbsSrvc.getCities().find(c => c.toLowerCase() === city.toLowerCase())
  const hasSuburbRecord =
    city &&
    suburb &&
    !!suburbsSrvc.getSuburbsByCity(city).includes(titleCase(suburb))

  switch (true) {
    case hasSuburbRecord:
      return {
        text: titleCase(suburb),
        url: sanitizeUrl(`/${city}/${suburb}`),
      }
    case isCitySupported:
      return {
        text: titleCase(city),
        url: sanitizeUrl(`/${city}`),
      }
    case !!(city || suburb):
      return {
        text: titleCase(city || suburb),
        disabled: true,
      }
    default:
  }
}

export const sanitizeDescription = desc => {
  if (desc) {
    return String(desc).replace('%u2019', "'")
  }

  return ''
}
